// extracted by mini-css-extract-plugin
export default {"loader":"cute_loader__FqZAg","eyeShade":"cute_eyeShade__Ov78W","eyeMove":"cute_eyeMove__Z+Um1"};